import { defineChain } from 'viem'

export const memolayer = defineChain({
	id: 985,
	name: 'MemoMegrez',
	network: 'MemoMegrez',
	nativeCurrency: {
		decimals: 18,
		name: 'Ether',
		symbol: 'ETH',
	},
	rpcUrls: {
		default: {
			http: ['https://chain.metamemo.one:8501'],
			webSocket: ['wss://rpc.memolayer.org'],
		},
		public: {
			http: ['https://chain.metamemo.one:8501'],
			webSocket: ['wss://rpc.memolayer.org'],
		},
	},
	blockExplorers: {
		default: { name: 'Explorer', url: 'https://memoscan.org' },
	},
})